<template>
  <b-modal
    id="delete-violation-modal"
    title="Delete Violation"
  >
    <h4 class="text-center">
      Are you sure you want to delete this rule?
    </h4>
    <template #modal-footer="{close}">
      <b-row style="width:100%">
        <b-col md="6">
          <b-button
            block
            variant="danger"
            :disabled="submitting"
            @click="close"
          >
            Cancel
          </b-button>
        </b-col>
        <b-col md="6">
          <b-button
            block
            variant="primary"
            :disabled="submitting"
            @click="deleteHandler"
          >
            <BSpinner
              v-if="submitting"
              small
            />
            <span v-else>Confirm</span>
          </b-button>
        </b-col>
      </b-row>
    </template>
  </b-modal>
</template>

<script>
import {
  BModal, BButton, BSpinner, BRow, BCol,
} from 'bootstrap-vue'
import { ref } from '@vue/composition-api'
import axiosIns from '@/libs/axios'

export default {
  components: {
    BModal, BButton, BSpinner, BRow, BCol,
  },
  props: {
    violation: {
      type: Object,
      default: undefined,
    },
  },
  setup(props, ctx) {
    const submitting = ref(false)
    const deleteHandler = async () => {
      try {
        submitting.value = true
        await axiosIns.delete(`/drivers/violations/types/${props.violation.id}`)
        ctx.emit('deleted')
        ctx.root.$bvModal.hide('delete-violation-modal')
      } finally {
        submitting.value = false
      }
    }
    return {
      submitting,
      deleteHandler,
    }
  },
}
</script>

    <style>

    </style>
